<template>
  <el-dialog v-if="showOffice" v-el-drag-dialog class="busi-form-container__dialog" :visible.sync="showOffice" :close-on-click-modal="false" width="900px" :append-to-body="appendToBody" :title="dialogTitle">
      <div class="weboffice-container">
          <div style="width: 100%" class="el-table el-table--fit el-table--border">
              <div class="el-table__body-wrapper">
                  <table cellspacing="0" cellpadding="0" border="0" style="width: 100%" class="el-table__body">
                      <tbody>
                          <tr v-if="!installedVer">
                              <td style="padding: 6px 15px; line-height: 30px">
                                  <div class="item">
                                      <div v-text-lbl="'solutions'" class="title" :hint="downloadHint">{{ downloadHint }} ，您可以选择以下解决方案：</div>
                                  </div>
                                  <div v-if="os === 'Windows'" class="item">
                                      <div v-text-lbl="'solutionsText1'" class="title">一、安装正文编辑器</div>
                                      <span v-text-lbl="'solutionsText2'">1、请点击链接，下载并安装正文编辑器：</span>

                                      <el-link v-pageBtn-lbl="'download'" type="primary" :href="webOfficeDownloadUrl" :underline="false">下载</el-link>
                                      <br />
                                      <span v-text-lbl="'solutionsText3'">2、安装完成后请刷新网页或重启电脑，重新点击“编辑正文”。</span>

                                      <div v-if="protocol === 'http'">
                                          <span v-text-lbl="'solutionsText4'">3、如果您已经安装正文编辑器但系统未检测到，您可以尝试以下方式：</span>
                                          <span v-text-lbl="'solutionsText5'">（1）、在浏览器地址栏中输入chrome://flags/#block-insecure-private-network-requests，右侧的Default改为Disabled，关闭浏览器，重新登录打开处理单，点击“编辑正文”。</span>
                                          <span v-text-lbl="'solutionsText6'">（2）、如果尝试以上设置仍然检测不到，请下载并安装Chrome极速浏览器，使用极速浏览器访问系统。</span>
                                      </div>
                                  </div>
                                  <div class="item">
                                      <div class="title">
                                          {{ os === 'Windows' ? '二' : '一' }}
                                          <span v-text-lbl="'solutionsText7'">、安装WPS Office专业版</span>
                                      </div>
                                      <span v-text-lbl="'solutionsText8'">请联系管理员获取WPS Office专业版安装包。</span>
                                  </div>
                                  <div class="item">
                                      <!--v-if="openType === 'Redlining' || openType === 'RedliningOnce' || openType === 'SignedFile'" -->
                                      <div class="title">
                                          {{ os === 'Windows' ? '三' : '二' }}
                                          <span v-text-lbl="'solutionsText9'">、手动上传文件</span>
                                      </div>
                                      <span v-text-lbl="'solutionsText10'">请点击链接下载文件到本地，处理完成后手动上传：</span>

                                      <el-link v-if="openType !== 'SignedFile'" v-text-lbl="'docFile'" type="primary" :href="bodyFileUrl" :underline="false">正文DOC文件</el-link>
                                      <el-link v-if="openType === 'Redlining' || openType === 'RedliningOnce'" v-text-lbl="'redFile'" type="primary" :href="redTitleFileUrl" :underline="false">红头文件模板</el-link>
                                      <el-link v-if="openType === 'SignedFile'" v-text-lbl="'dgzFile'" type="primary" :href="redTitleFileUrl" :underline="false">红头文件模板</el-link>
                                      <el-upload ref="upload" :on-change="handleUploadChange" action="" :multiple="false" :file-list="fileList" :show-file-list="false" :auto-upload="false" :with-credentials="true" :accept="accept">
                                          <el-input v-model="uploadAttach.fileName" size="small" name="uploadAttachFileName" :placeholder="$tx('ecoa.webOffice.fileUpload', '请选择待上传正文文件')">
                                              <el-button slot="append" size="mini" icon="el-icon-upload2" />
                                          </el-input>
                                      </el-upload>
                                  </div>
                                  <div v-if="libreOffice" class="item">
                                      <div class="title">
                                          {{ os === 'Windows' ? '四' : '三' }}
                                          <span v-text-lbl="'solutionsText11'">、使用在线文档编辑器</span>
                                      </div>
                                      <span v-text-lbl="'solutionsText12'">请点击链接，打开在线文档编辑器：</span>
                                      <el-link v-if="openType !== 'SignedFile'" v-pageBtn-lbl="'onlineEditor'" type="primary" :underline="false" @click="openerLibreoffce">在线编辑器</el-link>
                                  </div>
                              </td>
                          </tr>
                          <!-- <tr v-else-if="downloadHint.indexOf('新版') !== -1"> -->
                          <tr v-else-if="downloadHint !== $tx('ecoa.webOffice.hasNewEditor', '检测到有新版正文编辑器')">
                              <td style="padding: 6px 15px; line-height: 30px">
                                  <div class="item">
                                      <div class="title">{{ downloadHint }}</div>
                                      <div v-text-lbl="'curBb'" :curBb="installedVer">当前版本：{{ installedVer }}</div>
                                      <div v-text-lbl="'newBb'" :curVer="curVer">新&ensp;版&ensp;本：{{ curVer }}</div>

                                      <span v-text-lbl="'solutionsText13'">请点击链接下载并安装新版正文编辑器：</span>
                                      <el-link v-pageBtn-lbl="download" type="primary" :href="webOfficeDownloadUrl" :underline="false">下载</el-link>
                                  </div>
                              </td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </div>
      </div>
      <div slot="footer" class="dialog-footer">
          <el-button v-pageBtn-lbl="'close'" plain icon="el-icon-close" @click="showOffice = false">关 闭</el-button>
          <!-- <el-button v-if="downloadHint.indexOf('新版') === -1" type="primary" :disabled="uploading" icon="el-icon-check" @click="submitForm">{{ $tx('ecoa.common.upload') }}</el-button> -->
          <el-button v-if="downloadHint !== $tx('ecoa.webOffice.hasNewEditor', '检测到有新版正文编辑器')" v-pageBtn-lbl="'upload'" type="primary" :disabled="uploading" icon="el-icon-check" @click="submitForm">上传</el-button>
      </div>
  </el-dialog>
</template>

<script>
import { formatFileSize, determineOS, formatTime } from '@/global/utils/index'
const { bodyDocHistoryVer } = require('@/wapp/settings')

export default {
    name: 'WebOffice',
    props: {
        bodyfile: {
            type: Object,
            default: function () {
                return null
            }
        },
        accept: { type: String, default: '.doc,.docx,.pdf' }
    },
    data: function () {
        return {
            bodyDocHistoryVer: bodyDocHistoryVer,
            locationProtocolHostname: location.protocol + '://' + location.hostname,
            showOffice: false,
            dialogTitle: this.$tx('common.operationTip', '操作提示'),
            installedVer: '', // 当前安装旧版本
            curVer: '1.3.0', // 当前发布编辑正文控件版本号,需要与"/wapp/workflow/webOffice/"目录下的exe安装程序 版本一致
            downloadHint: '',
            loginUser: this.$store.getters.loginUser,
            fanwen_url: '', // 范文url
            openType: '', // 打开类型
            fileList: [], // 待上传文件列表
            uploadAttach: {}, // 手动上传正文文件
            placeholder: '请选择待上传正文文件',
            uploading: false, // 是否正在上传
            bodyFileUrl: '', // 正文doc源文件下载地址
            redTitleFileUrl: '', // 红头文件模板下载地址
            os: '', // 操作系统类型
            protocol: 'http', // 站点访问协议
            libreOffice: false, // 是否启用LibreOffice
            isEvenNumberPage: 0 // 是否偶数页面
        }
    },
    computed: {
        webOfficeDownloadUrl() {
            return '/apps/ecyoa.assistant.v' + this.curVer + '.exe'
        }
    },
    watch: {},
    created() {
        this.$bus.on('btnOpenWordClick', this.btnOpenWordClick)
        this.$bus.on('btnModifyFlTypeClick', this.btnModifyFlTypeClick)
        this.$bus.on('btnNoTitleModifyFlTypeClick', this.btnNoTitleModifyFlTypeClick)
        this.$bus.on('btnCreateCpbClick', this.btnCreateCpbClick)
        this.$bus.on('btnOpenScanApp', this.btnOpenScanApp)

        // winodws系统，优先使用易臣编辑正文本地控件
        this.os = determineOS()

        if (this.os === 'Windows') this.$vnode.context.officeType = 'ecexe'

        const reg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/
        if (location.protocol) {
            if (location.protocol.split(':')[0] === 'https' && reg.test(location.hostname)) {
                this.protocol = 'https'
            }
        }
    },
    beforeDestroy() {
        this.$bus.off('btnOpenWordClick', this.btnOpenWordClick)
        this.$bus.off('btnModifyFlTypeClick', this.btnModifyFlTypeClick)
        this.$bus.off('btnNoTitleModifyFlTypeClick', this.btnNoTitleModifyFlTypeClick)
        this.$bus.off('btnCreateCpbClick', this.btnCreateCpbClick)
        this.$bus.off('btnOpenScanApp', this.btnOpenScanApp)
    },
    mounted() {
        if (this.$vnode.context.commandBar) {
            const btns = this.$vnode.context.commandBar.filter((item) => {
                if (item.btnName === '编辑正文' || item.btnName === '套红' || item.btnName === '重新套红' || item.btnName === '修改红头') {
                    return item.btnName
                }
            })

            if (btns.length > 0) {
                this.queryWebOfficeVersion()
            }
        } else if (this.$vnode.context.openType && this.$vnode.context.openType === 'attachEdit') {
            this.queryWebOfficeVersion()
        }
    },

    methods: {
        rollElement(selector) {
            const element = document.querySelector(selector)
            document.querySelector('.mainform-container').scrollTop = Number(element.offsetTop) - 45
        },
        openerLibreoffce() {
            this.$set(this.$vnode.context, 'officeType', 'ech5')
            setTimeout(() => {
                this.$bus.emit('btnOpenWordClick', this.$vnode.context, this.openType)
            }, 100)
        },

        // 套红事件
        /**
       * redTitle 模式 更换红头事件 -- 所有编辑方式通用方法
       * @param {*} $scope
       */
        btnModifyFlTypeClick($scope) {
            this.validateEditModeWithPrompt($scope)
        },
        /**
       * NoTitle 模式 套红头事件 -- 所有编辑方式通用方法
       * @param {*} $scope
       */
        btnNoTitleModifyFlTypeClick($scope) {
            this.validateEditModeWithPrompt($scope)
        },
        /**
       * 查询红头模版前的校验操作 -- 所有编辑方式通用方法
       * @param {*} $scope
       */
        validateEditModeWithPrompt($scope) {
            // 非内嵌需带上此校验
            if ($scope.InlineTextEditor) {
                return
            }
            let confirmMessage, officeType
            if ($scope.wfInstance.passenger.docEditMode === 'NoTitle') {
                if ($scope.vo.signedFileName) {
                    // 简化条件判断
                    // confirmMessage = '该公文已经盖章，重新编辑正文后需要重新盖章！<br>是否继续？'
                    confirmMessage = this.$tx('ecoa.webOffice.signedFileNameConfirm', '该公文已经盖章，重新编辑正文后需要重新盖章！') + '<br>' + this.$tx('ecoa.webOffice.signedFileNameConfirm2', '是否继续？')

                    officeType = 'RedliningOnce' // 如果是在NoTitle模式下，并且有签名文件，则使用'RedliningOnce'
                } else if ($scope.wfInstance.haveDoc === 2) {
                    // confirmMessage = '该公文已经套过红！<br>是否继续？'
                    confirmMessage = this.$tx('ecoa.webOffice.haveDocConfirm', '该公文已经套过红！') + '<br>' + this.$tx('ecoa.webOffice.signedFileNameConfirm2', '是否继续？')

                    officeType = 'Redlining' // 如果是NoTitle模式下且再次套红（haveDoc为2），则使用'Redlining'
                } else {
                    officeType = 'Redlining' // 否则默认使用'Redlining'
                }
            } else {
                if ($scope.vo.signedFileName) {
                    // confirmMessage = '该公文已经盖章，重新编辑正文后需要重新盖章！<br>是否继续？'
                    confirmMessage = this.$tx('ecoa.webOffice.signedFileNameConfirm', '该公文已经盖章，重新编辑正文后需要重新盖章！') + '<br>' + this.$tx('ecoa.webOffice.signedFileNameConfirm2', '是否继续？')

                    officeType = 'OpenTwoDoc' // 如果不是NoTitle模式下，且有签名文件，则使用'OpenTwoDoc'
                } else {
                    officeType = 'OpenTwoDoc' // 否则默认使用'OpenTwoDoc'
                }
            }

            if (confirmMessage) {
                this.$confirm(confirmMessage, this.$tx('common.confirmOperate', '确认操作'), { type: 'warning', dangerouslyUseHTMLString: true })
                    .then(() => {
                        this.ModifyFlTypeClick($scope, officeType)
                    })
                    .catch(() => {
                        return
                    })
            } else {
                // 如果没有需要确认的消息，则直接调用函数
                this.ModifyFlTypeClick($scope, officeType)
            }
        },
        /**
       * 选择红头事件 -- 所有编辑方式通用方法
       * @param {*} $scope
       */
        ModifyFlTypeClick($scope, officeType) {
            if ($scope.wfInstance.module === 'jyap') {
                this.validateAndEditFwmbTemplate($scope, '', officeType)
            } else {
                this.fetchFwmbTemplateData($scope).then((res) => {
                    if (res.code === 'success') {
                        debugger
                        // 匹配文件字号相同的红头模版，并设置所有模板的value和text属性
                        let mbList = []
                        if ($scope.vo && $scope.vo.flWord) {
                            // 过滤出文件字号相同的红头模版
                            mbList = res.body.listdata.filter((item) => item.fileWord === $scope.vo.flWord)

                            // 如果找到了匹配的模版，则替换res.body.listdata
                            if (mbList.length > 0) {
                                res.body.listdata = mbList
                            }
                        }
                        // 无论是否找到了匹配的模版，都设置所有模板的value和text属性
                        res.body.listdata.forEach((item) => {
                            item.value = item.id
                            item.text = item.name
                        })

                        if (res.body.listdata.length > 1) {
                            this.$bus.emit(
                                'openListitemDialog',
                                '选择红头模板',
                                res.body.listdata,
                                (rst) => {
                                    if (rst.code === 'success') {
                                        const gwmb = res.body.listdata.filter((item) => {
                                            if (item.id === rst.value) return true
                                        })
                                        this.validateAndEditFwmbTemplate($scope, gwmb, officeType)
                                    }
                                },
                                $scope.vo.gwmbId,
                                '红头模板',
                                '请选择红头模板'
                            )
                        } else if (res.body.listdata.length === 1) {
                            // 调用选择模版后处理方法

                            this.validateAndEditFwmbTemplate($scope, res.body.listdata, officeType)
                        }
                    } else {
                        // this.$alert(res.message, '操作提示', { type: 'error' })
                        this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                    }
                })
            }
        },
        /**
       * 请求发文模版数据 -- 所有编辑方式通用方法
       * @param {*} $scope
       */
        fetchFwmbTemplateData($scope) {
            return this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: { orderBy: 'sortNo,name' },
                data: [
                    { compare: '=', field: 'orgCode', value: $scope.wfInstance.orgCode },
                    { compare: '=', field: 'status', value: 1 },
                    { compare: '=', field: 'mbType', value: 'fwmb' }
                ],
                url: 'gwgl/fwmb/querydata'
            })
        },
        /**
       * 拿到红头模版后的调用编辑正文操作 -- ecexe 通用方法
       * @param {*} $scope
       */
        validateAndEditFwmbTemplate($scope, gwmb, officeType) {
            if ($scope.wfInstance.module === 'jyap') {
                var res = []
                if ($scope.vo.busiType) {
                    res = $scope.vo.passenger.flTypeOptions.filter(item => item.value === $scope.vo.busiType)
                } else {
                    res.push($scope.vo.passenger.flTypeOptions[0])
                }
                $scope.vo.gwmbId = res[0].gwmb.id
                this.isEvenNumberPage = res[0].gwmb.isEvenNumberPage
            } else {
                $scope.vo.flWord = gwmb[0].fileWord
                $scope.vo.flFormName = gwmb[0].formTitle
                $scope.vo.flRedTitle = gwmb[0].fileHeader
                $scope.vo.gwmbId = gwmb[0].id
                $scope.vo.flType = gwmb[0].name
                this.isEvenNumberPage = gwmb[0].isEvenNumberPage
            }
            this.btnOpenWordClick($scope, officeType)
        },

        btnCreateCpbClick($scope, openType) {
            this.btnOpenWordClick($scope, openType)
        },
        /**
       * 扫描文件
       */
        btnOpenScanApp($scope, type = 'SCAN') {
            const _this = this
            var appUrl = location.href.split('#')[0]
            if (appUrl.endsWith('/')) {
                appUrl = appUrl.substring(0, appUrl.length - 1)
            }
            let productCode = sessionStorage.getItem('productCode')
            if (!productCode) {
                productCode = window.productCode
            }
            const dataJson = {
                fileUploadUrl: '',
                token: '',
                postfield: `bodyDocId=${$scope.wfInstance.bodyDocId}&module=${$scope.wfInstance.module}`,
                fileName: '文件正文' + '.pdf'
            }

            dataJson.token = 'ECWEB-JWTSSO-TOKEN-' + productCode + '=' + window.$auth.getToken()

            dataJson.fileUploadUrl = appUrl + `/apigw/` + $scope.wfAttachUrl + `/upload?module=` + $scope.wfAttachUrl.split('/')[1] + `&busiDataId=${$scope.vo.id}&attachsType=${type}`

            this.xmlAjax({
                url: 'http://127.0.0.1:7900/api/GetOcxStatus',
                method: 'post',
                data: '{"xquery":"ocxstatus"}',
                onload: function(e) {
                    _this.xmlAjax({
                        url: 'http://127.0.0.1:7900/api/OpenScanApp',
                        method: 'post',
                        data: JSON.stringify(dataJson),
                        onload: function(e) {
                            console.log(this.responseText)
                            if (this.status === 200 || this.status === 304) {
                                setTimeout(() => {
                                    _this.onEditOrcFinished($scope, type)
                                }, 1000)
                            }
                        }
                    })
                }
            })
        },
        /**
       * 检测 扫描文件是否完成
       */
        onEditOrcFinished($scope, type) {
            const _this = this
            const url = 'http://127.0.0.1:7900/api/GetOcxStatus'
            this.xmlAjax({
                url: url,
                method: 'post',
                data: '{"xquery":"ocxstatus"}',
                onload: function(e) {
                    if (this.status === 200 || this.status === 304) {
                        const jsonObj = JSON.parse(this.responseText.replace('\r\n', '').replace('\n', '').replace('}0', '}'))
                        if (jsonObj.result === 'finished') {
                            var attachs = jsonObj.msg[0].body.uploadAttachList
                            if (type === 'BODY') {
                                attachs[0].fileName = '文件正文' + '.pdf'
                            } else if (type === 'SMATTACH') {
                                attachs[0].fileName = '申请资料扫描件' + '.pdf'
                            } else {
                                attachs[0].fileName = '盖章资料扫描件' + '.pdf'
                            }
                            console.log(attachs, 'attachs')
                            if (type === 'BODY') {
                                $scope.bodyfile = attachs[0]
                                $scope.wfInstance.haveDoc = 2
                                $scope.bodyfile.notDelete = true
                                $scope.activeName = 'second'
                                _this.$nextTick(() => {
                                    $scope.btnSubmitClick('AutoSave')
                                })
                            } else {
                                $scope.vo.passenger.attachments.push(attachs[0])
                                setTimeout(() => {
                                    _this.$nextTick(() => {
                                        $scope.btnSubmitClick('AutoSave')
                                    })
                                }, 1000)
                            }
                        } else if (jsonObj.result === 'work') {
                            setTimeout(() => {
                                _this.onEditOrcFinished($scope, type)
                            }, 1000)
                        }
                    }
                }
            })
        },
        /**
       * 编辑正文打开事件
       */
        btnOpenWordClick($scope, openType, fbUrl) {
            if ($scope.officeType !== 'ecexe') {
                return
                // } else if (this.downloadHint.indexOf('新版') !== -1) {
            } else if (this.downloadHint === this.$tx('ecoa.webOffice.hasNewEditor', '检测到有新版正文编辑器')) {
                this.dialogTitle = this.$tx('ecoa.webOffice.updateTip', '更新提示')
                this.showOffice = true
                return
            } else if (!this.installedVer && window.wpsInstalled) {
                setTimeout(() => {
                    $scope.officeType = 'wpsjs'
                    console.log($scope.officeType, ' window.wpsInstalled')
                    this.$nextTick(() => {
                        this.$bus.emit('btnOpenWordClick', $scope, openType, fbUrl)
                    })
                }, 0)

                return
            }
            this.fanwen_url = fbUrl
            this.openType = openType
            const _this = this

            let productCode = sessionStorage.getItem('productCode')
            if (!productCode) {
                productCode = window.productCode
            }

            $scope.formValidate(() => {
                const appUrl = location.href.split('#')[0] // url
                const token = 'ECWEB-JWTSSO-TOKEN-' + productCode + '=' + window.$auth.getToken()
                const WFBusiDataId = $scope.vo.id
                let WFBodyDocId = $scope.wfInstance.bodyDocId ? $scope.wfInstance.bodyDocId : ''
                const WfModule = $scope.wfInstance.module ? $scope.wfInstance.module : ''
                const flSubject = $scope.vo.flSubject

                //Word编辑器，显示使用title属性,saveAs为下载保存到本机的文件名
                let saveAs = WFBodyDocId + '.doc'
                if (openType === 'NoTracks') {
                    saveAs = 'NoTracks_' + saveAs
                } else if (openType === 'Redlining' || (openType === 'RedliningOnce' && $scope.wfInstance.passenger.docEditMode === 'NoTitle')) {
                    saveAs = 'RedTitle_' + saveAs
                } else if (openType === 'attachEdit') {
                    saveAs = this.$vnode.context.vo.id + '.doc'
                }

                let downUrl = ''
                let oldFileDownUrl = ''
                let insertFileDownUrl = ''
                let postfield = 'busiDataId=' + WFBusiDataId + '&bodyDocId=' + WFBodyDocId + '&module=' + WfModule
                this.placeholder = '请选择待上传正文文件'

                if (openType === 'NoTracks') {
                    //清稿
                    if ($scope.noTracksFile && $scope.noTracksFile.fileName) {
                        downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=NoTracks_' + WFBodyDocId + '.doc&attachsType=BODY&saveAs=' + saveAs
                    } else {
                        downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=' + WFBodyDocId + '.doc&attachsType=BODY&saveAs=' + saveAs
                    }
                } else if ((openType === 'OpenTwoDoc' || openType === 'OpenTwoDoc') && $scope.wfInstance.haveDoc === 2) {
                    // RedTitle 模式下  正文编辑修改红头
                    // 取源文件
                    if ($scope.noTracksFile && $scope.noTracksFile.fileName) {
                        oldFileDownUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=NoTracks_' + WFBodyDocId + '.doc&attachsType=BODY&saveAs=' + saveAs
                    } else {
                        oldFileDownUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=' + WFBodyDocId + '.doc&attachsType=BODY&saveAs=' + saveAs
                    }
                    if ($scope.vo.gwmbId !== undefined && $scope.vo.gwmbId !== null && $scope.vo.gwmbId !== '') {
                        // 取红头模版
                        downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/gwgl/fwmb/download?id=' + $scope.vo.gwmbId + '&dataField=fileContent&nameField=mbFileName'
                    } else {
                        downUrl = appUrl + 'templates/Editor.doc'
                    }
                } else if (openType === 'SignedFile' && $scope.wfInstance.haveDoc === 2) {
                    this.placeholder = '请选择待上传盖章文件'

                    // 盖章
                    if ($scope.wfInstance.haveDoc === 0) {
                        // this.$alert('请先编辑或上传正文。', '操作提示', { type: 'warning' })
                        this.$alert(this.$tx('ecoa.webOffice.uploadFileAlert', '请先编辑或上传正文。'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                        return
                    }
                    downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=' + WFBodyDocId + '.doc&attachsType=BODY'
                } else if (openType === 'Redlining' || openType === 'RedliningOnce') {
                    this.placeholder = '请选择待上传套红文件'

                    // NoTitle 模式下 套红
                    // postfield = 'busiDataId=' + WFBusiDataId + '&bodyDocId=RedTitle' + WFBodyDocId + '&module=' + WfModule
                    postfield = 'busiDataId=' + WFBusiDataId + '&module=' + WfModule
                    // 源文件   如果有清稿文件则取清稿文件attachsName
                    if ($scope.noTracksFile && $scope.noTracksFile.fileName) {
                        insertFileDownUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=NoTracks_' + WFBodyDocId + '.doc&attachsType=BODY&' // 正文
                    } else {
                        insertFileDownUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=' + WFBodyDocId + '.doc&attachsType=BODY&' // 正文
                    }
                    // 红头模版
                    downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/gwgl/fwmb/download?id=' + $scope.vo.gwmbId + '&dataField=fileContent&nameField=mbFileName&saveAs=' + saveAs // 红头模版

                    if ($scope.wfInstance.haveDoc === 0) {
                        // 无正文编辑，直接套红，直接用默认空白模版
                        insertFileDownUrl = appUrl + 'templates/Editor.doc' // 若无正文则读空白模版
                    }
                } else if ($scope.wfInstance && $scope.wfInstance.haveDoc === 2 && openType === undefined) {
                    // 套红后正文编辑，或带红头编辑正文
                    downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=' + WFBodyDocId + '.doc&attachsType=BODY&saveAs=' + saveAs
                } else if (openType === 'attachEdit') {
                    // 附件编辑
                    downUrl = this.$vnode.context.downUrl
                    WFBodyDocId = this.$vnode.context.vo.mbFileName ? this.$vnode.context.vo.mbFileName : this.$vnode.context.vo.name + '-' + this.$vnode.context.vo.mbVer
                    downUrl += '&saveAs=' + saveAs
                } else if (openType !== undefined && openType !== 'OpenTwoDoc') {
                    if ($scope.wfInstance.status === -1) {
                        // this.$alert('请先保存文件。', '操作提示', { type: 'warning' })
                        this.$alert(this.$tx('ecoa.webOffice.saveFileAlert', '请先保存文件。'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                        return
                    } else if ($scope.vo.flCpbTemplateId && $scope.vo.flCpbTemplateId !== '') {
                        downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/gwgl/cpbFile/printCpbFileDoc?busiDataId=' + $scope.vo.id + '&cpbTemplateId=' + $scope.vo.flCpbTemplateId + `&productCode=${productCode}`
                    } else {
                        // this.$alert('当前文件没有关联呈批表/拟稿纸模板。', '操作提示', { type: 'warning' })
                        this.$alert(this.$tx('ecoa.webOffice.noModuleAlert', '当前文件没有关联呈批表/拟稿纸模板。'), this.$tx('common.operationTip', '操作提示'), { type: 'warning' })
                        return
                    }
                } else if ($scope.wfInstance.haveDoc === 0) {
                    // 公文发文初始化
                    if ($scope.wfInstance.passenger.docEditMode === 'NoTitle') {
                        // NoTitle 直接启用空白模版进行正文编辑
                        downUrl = appUrl + 'templates/Editor.doc?saveAs=' + saveAs
                    } else {
                        // RedTitle 启用 模版
                        if ($scope.vo.gwmbId !== undefined && $scope.vo.gwmbId !== null && $scope.vo.gwmbId !== '') {
                            downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/gwgl/fwmb/download?id=' + $scope.vo.gwmbId + '&dataField=fileContent&nameField=mbFileName'
                        } else if ($scope.wfInstance.module === 'hytz') {
                            downUrl = appUrl + 'templates/HytzEditor.doc'
                        } else {
                            downUrl = appUrl + 'templates/Editor.doc'
                        }
                    }
                } else {
                    if ($scope.wfInstance.module === 'jyap') {
                        var id = $scope.vo.passenger.flTypeOptions[0].gwmb.id
                        downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + `/gwgl/fwmb/download?id=${id}&dataField=fileContent&nameField=mbFileName`
                        insertFileDownUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + `/hygl/jyap/downloadById?inline=true&attachIds=${this.bodyfile.id}&saveAs=${this.bodyfile.fileName}&fileName=${this.bodyfile.fileName}`
                    } else {
                        downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/downloadByName?busiDataId=' + WFBusiDataId + '&attachsName=' + WFBodyDocId + '.doc&attachsType=BODY&saveAs=' + saveAs
                    }
                }
                // 使用范文
                if (this.fanwen_url) downUrl = appUrl + process.env.VUE_APP_BASE_API.substring(1) + this.fanwen_url

                // 文件附件，每个附件一行
                let attachNames = ''
                if ($scope.attachments) {
                    let index = 1
                    $scope.attachments.forEach((attach) => {
                        if (attach.fileType === 'ATTACH') {
                            attachNames += index++ + '、' + attach.fileName + '<br/>'
                        }
                    })
                    // 将<br/>转换为word可识别的换行符
                    let blankDiv = document.querySelector('.convert-br-div')
                    if (!blankDiv) {
                        blankDiv = document.createElement('div')
                        blankDiv.classList.add('convert-br-div')
                        document.body.appendChild(blankDiv)
                    }
                    blankDiv.innerHTML = attachNames
                    attachNames = blankDiv.innerText
                }

                // console.log(downUrl)
                let url = 'http://127.0.0.1:7900/api/GetOcxStatus'

                this.xmlAjax({
                    url: url,
                    method: 'post',
                    data: '{"xquery":"ocxstatus"}',
                    onload: function (e) {
                        if (this.status === 200 || this.status === 304) {
                            const bookmarks = []
                            let bookmarkFun = ''
                            const moment = require('moment')
                            const flCreateDate = moment($scope.vo.flCreateDate).format('YYYY年MM月DD日')
                            const flSignDate = $scope.vo.flSignDate ? moment($scope.vo.flSignDate).format('YYYY年MM月DD日') : null

                            if ($scope.wfInstance.haveDoc === 0 || openType === 'Redlining' || openType === 'RedliningOnce') {
                                bookmarkFun = 'Add'
                            } else {
                                bookmarkFun = 'Replace'
                            }
                            bookmarks.push({ bookName: 'FlSubject', bookValue: $scope.vo.flSubject == null ? '' : $scope.vo.flSubject })
                            bookmarks.push({ bookName: 'FlCreateDate', bookValue: flCreateDate == null ? '' : flCreateDate })
                            bookmarks.push({ bookName: 'FlCreator', bookValue: $scope.vo.flCreator == null ? '' : $scope.vo.flCreator })
                            bookmarks.push({ bookName: 'FlCreatorPhone', bookValue: $scope.vo.flCreatorPhone == null ? '' : $scope.vo.flCreatorPhone })
                            bookmarks.push({ bookName: 'FlJbr', bookValue: $scope.vo.flJbr == null ? '' : $scope.vo.flJbr })
                            bookmarks.push({ bookName: 'FlMainSend', bookValue: $scope.vo.flMainSend == null ? '' : $scope.vo.flMainSend })
                            bookmarks.push({ bookName: 'FlSignOrg', bookValue: $scope.vo.flSignOrg == null ? '' : $scope.vo.flSignOrg })
                            bookmarks.push({ bookName: 'Copies', bookValue: $scope.vo.flPrintCount == null ? '' : $scope.vo.flPrintCount + '' })
                            bookmarks.push({ bookName: 'FileCode', bookValue: $scope.vo.flFwzh == null ? '' : $scope.vo.flFwzh })
                            bookmarks.push({ bookName: 'FlCopySend', bookValue: $scope.vo.flCopySend == null ? '' : $scope.vo.flCopySend })
                            bookmarks.push({ bookName: 'FlSignDate', bookValue: flSignDate == null ? '' : flSignDate })
                            bookmarks.push({ bookName: 'FlPrintTime', bookValue: $scope.vo.flPrintTime == null ? '' : $scope.vo.flPrintTime })
                            bookmarks.push({ bookName: 'AttachNames', bookValue: attachNames })

                            if ($scope.wfInstance.module === 'hytz') {
                                bookmarks.push({ bookName: 'StartTime', bookValue: $scope.vo.startTime == null ? '' : $scope.vo.startTime.substring(0, 16) })
                                bookmarks.push({ bookName: 'EndTime', bookValue: $scope.vo.endTime == null ? '' : $scope.vo.endTime.substring(0, 16) })
                                bookmarks.push({ bookName: 'Address', bookValue: $scope.vo.address == null ? '' : $scope.vo.address })
                                bookmarks.push({ bookName: 'Compere', bookValue: $scope.vo.compere == null ? '' : $scope.vo.compere })
                                bookmarks.push({ bookName: 'Body', bookValue: $scope.vo.lContent == null ? '' : $scope.vo.Body })
                                bookmarks.push({ bookName: 'Leaders', bookValue: $scope.vo.leaders == null ? '' : $scope.vo.leaders })
                                bookmarks.push({ bookName: 'tixingshijian', bookValue: $scope.vo.flRegistTime == null ? '' : $scope.vo.flRegistTime.substring(0, 16) })
                                bookmarks.push({ bookName: 'flSignOrg', bookValue: $scope.wfInstance.orgName })
                                bookmarks.push({ bookName: 'fabushijian', flCreateDate })
                            }
                            if ($scope.wfInstance.module === 'jyap') {
                                bookmarks.push({ bookName: 'attendLeader', bookValue: $scope.vo.passenger.hyap.attendLeader == null ? '' : $scope.vo.passenger.hyap.attendLeader })
                                bookmarks.push({ bookName: 'attendName', bookValue: $scope.vo.passenger.hyap.attendName == null ? '' : $scope.vo.passenger.hyap.attendName })
                                bookmarks.push({ bookName: 'meetHost', bookValue: $scope.vo.passenger.hyap.meetHost == null ? '' : $scope.vo.passenger.hyap.meetHost })
                                bookmarks.push({ bookName: 'meetPlace', bookValue: $scope.vo.passenger.hyap.meetPlace == null ? '' : $scope.vo.passenger.hyap.meetPlace })
                                bookmarks.push({ bookName: 'sAttendName', bookValue: $scope.vo.passenger.hyap.sAttendName == null ? '' : $scope.vo.passenger.hyap.sAttendName })
                                bookmarks.push({ bookName: 'startTime', bookValue: $scope.vo.passenger.hyap.startTime == null ? '' : moment(new Date($scope.vo.passenger.hyap.startTime)).format('YYYY年MM月DD日') })
                                bookmarks.push({ bookName: 'summaryName', bookValue: $scope.vo.passenger.hyap.summaryName == null ? '' : $scope.vo.passenger.hyap.summaryName })
                                bookmarks.push({ bookName: 'xzSpTime', bookValue: $scope.vo.xzSpTime == null ? '' : moment(new Date($scope.vo.xzSpTime)).format('YYYY年MM月DD日') })
                                bookmarks.push({ bookName: 'toYear', bookValue: $scope.vo.toYear == null ? '' : $scope.vo.toYear })
                                bookmarks.push({ bookName: 'createNum', bookValue: $scope.vo.createNum == null ? '' : $scope.vo.createNum + '' })
                            }

                            // 附件编辑时直接取附件名，不需要拼doc
                            let fileName = ''
                            if (openType === 'NoTracks') {
                                fileName = 'NoTracks_' + WFBodyDocId + '.doc'
                            } else if (openType === 'attachEdit') {
                                fileName = WFBodyDocId
                            } else {
                                fileName = WFBodyDocId + '.doc'
                            }

                            // 判断当前编辑后是否需要生成 pdf
                            let savePdf = '1'
                            // 判断是否需要显示痕迹
                            let showRevisions = '0'
                            if (openType === 'NoTracks') {
                                // savePdf = '0'
                                showRevisions = '1'
                            }

                            const dataJson = {
                                userName: _this.loginUser.personName,
                                fileDownUrl: downUrl, // 红头模板 url
                                oldFileDownUrl: oldFileDownUrl, // 编辑正文本体
                                insertFileDownUrl: insertFileDownUrl, //  正文内容下载地址
                                fileUploadUrl: appUrl + process.env.VUE_APP_BASE_API.substring(1) + '/' + $scope.wfAttachUrl + '/upload',
                                fileName: fileName,
                                token: token,
                                formField: 'file',
                                postfield: postfield,
                                saveWord: '1',
                                saveHtml: '0',
                                savePdf: savePdf, // 是否需要存pdf
                                title: flSubject,
                                sysName: '易臣智慧云OA系统',
                                // ofdFilePath: 'D:\\test',
                                toolBtnSize: 'medium', // small、medium、large
                                bookmarks: bookmarks,
                                showRevisions: showRevisions, // 是否需要显示痕迹
                                bookmarkFun: bookmarkFun,
                                bookName: 'Body',
                                bookValue: ''
                            }

                            if (openType !== 'attachEdit' && openType !== 'PrintFile') {
                                // 启用后端上传文件权限校验功能，编辑正文时，禁止提交后再上传正文
                                dataJson.fileUploadUrl += '?tnkey=' + $scope.curTN.staffID + '_' + $scope.curTN.tnID
                                dataJson.fileUploadUrl += '&bodyDocId=' + $scope.wfInstance.bodyDocId
                                if (productCode !== '') {
                                    dataJson.fileUploadUrl += '&productCode=' + productCode
                                }
                            } else {
                                // 附件编辑的上传地址从调用组件取
                                dataJson.fileUploadUrl += '?' + $scope.uploadUrl
                            }

                            dataJson.showBtnToolbar = '1'
                            dataJson.showRevisions = '0'
                            dataJson.showBtnSaveExit = '1'
                            dataJson.showBtnSavePdf = '0'
                            dataJson.showBtnRevisions = '1'
                            dataJson.showBtnSave = '1'
                            dataJson.saveWord = '1'

                            if ($scope.status == 0 || $scope.status == -1) {
                                dataJson.trackRevisions = '0'
                            } else {
                                dataJson.trackRevisions = '1'
                            }

                            if (openType === 'NoTracks') {
                                dataJson.trackRevisions = '0' // 1:启用修订，0:禁用修订
                                dataJson.showRevisions = '1'

                                //启用自动保存上传功能，上传间隔，5分钟
                                dataJson.autoSaveUpload = '1' //字符串参数
                                dataJson.autoSaveInterval = 5 //数字参数，单位为分钟
                            } else if (openType === 'SignedFile') {
                                dataJson.fileName = openType + '_' + WFBodyDocId + '.doc'

                                dataJson.postfield += '&attachsType=BODY,BODY'

                                dataJson.trackRevisions = '0' // 1:启用修订，0:禁用修订
                                dataJson.showBtnRevisions = '0'
                                dataJson.showBtnSave = '0'
                                dataJson.savePdf = '1'
                            } else if (openType === 'Redlining' || openType === 'RedliningOnce') {
                                dataJson.fileName = 'RedTitle' + '_' + WFBodyDocId + '.doc'

                                // dataJson.postfield += '&attachsType=BODY'

                                dataJson.trackRevisions = '0' // 1:启用修订，0:禁用修订
                                dataJson.showBtnRevisions = '0'
                                dataJson.evenNumberPageSize = String(_this.isEvenNumberPage) // 最后一页是否必须偶数页，1：是，0：否
                            } else if (openType === 'attachEdit') {
                                dataJson.postfield += '&attachsType=ATTACH'
                                dataJson.trackRevisions = '0' // 1:启用修订，0:禁用修订 // 初始化
                            } else if (openType !== undefined && openType !== 'OpenTwoDoc') {
                                dataJson.fileName = openType + '_' + WFBodyDocId + '.doc'
                                dataJson.postfield += '&attachsType=' + openType //自定义类型

                                dataJson.trackRevisions = '0' // 1:启用修订，0:禁用修订
                                dataJson.saveWord = '0'
                                dataJson.showBtnSave = '0'
                                dataJson.showBtnSavePdf = '1'
                                dataJson.showBtnRevisions = '0'
                            } else {
                                if ($scope.wfInstance.status < 1 || openType === 'OpenTwoDoc' || openType === 'OpenTwoDoc' || openType === 'Redlining' || openType === 'RedliningOnce') {
                                    dataJson.trackRevisions = '0' // 1:启用修订，0:禁用修订 // 初始化
                                } else {
                                    dataJson.trackRevisions = '1' // 1:启用修订，0:禁用修订
                                }

                                dataJson.saveWord = '1'
                                dataJson.showBtnSave = '1'

                                //启用编辑正文历史版本保存功能
                                if (_this.bodyDocHistoryVer === 'everySave') {
                                    //每次编辑正文保存一个版本
                                    dataJson.postfield += '&fileId=' + WFBodyDocId + '&fileVer=' + formatTime(new Date(), 'YYYYMMDDHHmmss')
                                } else if (_this.bodyDocHistoryVer === 'everyTaskNode' && $scope.curTN.tnStartTime) {
                                    //版本号为当前环节开始时间，一个环节处理人只保留一个历史版本
                                    dataJson.postfield += '&fileId=' + WFBodyDocId + '&fileVer=' + $scope.curTN.tnStartTime.replaceAll('-', '').replaceAll(' ', '').replaceAll(':', '').replace('.', '')
                                }
                                //启用自动保存上传功能，上传间隔，5分钟
                                dataJson.autoSaveUpload = '1' //字符串参数
                                dataJson.autoSaveInterval = 5 //数字参数，单位为分钟
                            }

                            dataJson.devicePixelRatio = window.devicePixelRatio //屏幕缩放比例

                            console.log(dataJson, 'dataJson')

                            const jsonObj = JSON.parse(this.responseText)
                            if (jsonObj.result === 'ready') {
                                if (openType === 'OpenTwoDoc') {
                                    url = 'http://127.0.0.1:7900/api/OpenTwoDoc' // 原 RedTitle 模式 修改红头
                                } else if (openType === 'Redlining' || openType === 'RedliningOnce') {
                                    url = 'http://127.0.0.1:7900/api/InsertFile' // 新 NoTitle 模式 套红
                                } else if (openType === 'Approve') {
                                    url = 'http://127.0.0.1:7900/api/OpenApproveDoc' // 核稿？
                                } else {
                                    url = 'http://127.0.0.1:7900/api/OpenWord' // 初始 正文编辑
                                }

                                _this.xmlAjax({
                                    url: url,
                                    method: 'post',
                                    data: JSON.stringify(dataJson),
                                    onload: function (e) {
                                        // console.log(this.responseText)
                                        if (this.status === 200 || this.status === 304) {
                                            // alert('this is answer:' + this.responseText)
                                            const openRst = JSON.parse(this.responseText)
                                            if (openRst.result === 'success') {
                                                setTimeout(() => {
                                                    _this.onEditDocFinished($scope, openType)
                                                }, 1000)
                                            } else {
                                                // $scope.$alert('编辑正文打开文件失败！', '操作提示', { type: 'error' })
                                                $scope.$alert(this.$tx('ecoa.webOffice.failFileAlert', '编辑正文打开文件失败！'), this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                                                console.log('openWord dataJson=' + JSON.stringify(bookmarks))
                                            }
                                        }
                                    }
                                })
                            } else {
                                $scope.$confirm('系统检测到有正在编辑的文档，是否关闭文档并继续？', this.$tx('common.confirmOperate', '确认操作'), { type: 'warning' }).then(function () {
                                    url = 'http://127.0.0.1:7900/api/CloseWord'
                                    _this.xmlAjax({
                                        url: url,
                                        method: 'post',
                                        data: '{"action":"close"}',
                                        onload: function (e) {
                                            if (this.status === 200 || this.status === 304) {
                                                url = 'http://127.0.0.1:7900/api/OpenWord'
                                                _this.xmlAjax({
                                                    url: url,
                                                    method: 'post',
                                                    data: JSON.stringify(dataJson),
                                                    onload: function (e) {
                                                        if (this.status === 200 || this.status === 304) {
                                                            // alert("this is answer:"+this.responseText);
                                                        }
                                                    }
                                                })
                                            }
                                        }
                                    })
                                })
                            }
                        }
                    }
                    // 已打开模板
                })
            })
        },
        xmlAjax(config) {
            const url = config.url || ''
            const method = config.method || 'get'
            const async = config.async || true

            const data = config.data || {}
            const req = new XMLHttpRequest()
            req.open(method, url, async)
            req.setRequestHeader('Content-Type', 'application/json')
            if (typeof config.onload === 'function') {
                req.onload = config.onload
            }
            if (typeof config.ontimeout === 'function') {
                req.ontimeout = config.ontimeout
            }
            if (typeof config.onerror === 'function') {
                req.onerror = config.onerror
            }
            if (typeof config.onprogress === 'function') {
                req.onload.onprogress = config.onprogress
            }

            req.send(data)
        },
        queryWebOfficeVersion() {
            const _this = this
            const url = 'http://127.0.0.1:7900/api/GetSystemInfo'
            try {
                this.xmlAjax({
                    url: url,
                    method: 'post',
                    data: '{"type":"version"}',
                    onload: function (e) {
                        if (this.status === 200 || this.status === 304) {
                            const curVer = _this.curVer.split('.')
                            for (let i = 0; i < curVer.length; i++) {
                                curVer[i] = parseInt(curVer[i])
                            }

                            _this.installedVer = JSON.parse(this.responseText.replace('\r\n', '').replace('}0', '}')).result
                            const version = _this.installedVer.split('.')
                            for (let i = 0; i < version.length; i++) {
                                version[i] = parseInt(version[i])
                            }

                            if (version[0] < curVer[0] || (version[0] === curVer[0] && version[1] < curVer[1]) || (version[0] === curVer[0] && version[1] === curVer[1] && version[2] < curVer[2])) {
                                // _this.downloadHint = '检测到有新版正文编辑器'
                                _this.downloadHint = _this.$tx('ecoa.webOffice.hasNewEditor', '检测到有新版正文编辑器')
                            } else {
                                // _this.downloadHint = '正文编辑器已安装'
                                _this.downloadHint = _this.$tx('ecoa.webOffice.isInstallFile', '正文编辑器已安装')
                            }

                            // 模拟正文编辑器安装失败，动态加载WpsOffice，正式上线注销以下三行

                            // _this.installedVer = ''
                            // _this.downloadHint = '没有检测到正文编辑器'
                            // _this.downloadHint = _this.$tx('ecoa.webOffice.noFindEditor')
                            // _this.loadWpsOffice()
                        }
                    },
                    onerror: (e) => {
                        console.log('queryWebOfficeVersion error.')
                        // _this.downloadHint = '没有检测到正文编辑器'
                        _this.downloadHint = _this.$tx('ecoa.webOffice.noFindEditor', '没有检测到正文编辑器')
                        _this.loadWpsOffice()
                    }
                })
            } catch (e) {
                // _this.downloadHint = '没有检测到正文编辑器'
                _this.downloadHint = _this.$tx('ecoa.webOffice.noFindEditor', '没有检测到正文编辑器')
                _this.loadWpsOffice()
            }
        },
        loadWpsOffice() {
            const $scope = this.$vnode.context
            if (!$scope.$options.components['WpsOffice']) {
                let officeType = $scope.officeType
                $scope.officeType = ''

                const js = document.createElement('script')
                js.id = 'wps-js'
                js.src = 'plugins/wpsjs/wpsaddons/wpsjsrpcsdk.js'
                document.body.appendChild(js)
                js.onload = js.onreadystatechange = function () {
                    if (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete') {
                        if (Vue.options.components['WpsWebOffice']) {
                            $scope.$options.components['WpsOffice'] = Vue.options.components['WpsWebOffice']
                        } else {
                            $scope.$options.components['WpsOffice'] = $scope.$loadComponent('@/wapp/workflow/webOffice/WpsOffice')
                        }
                        officeType = 'wpsjs'
                        setTimeout(() => {
                            $scope.officeType = officeType
                            $scope.$forceUpdate()
                        }, 100)
                    }
                    js.onload = js.onreadystatechange = null
                }
            }
        },
        /**
       * 检测编辑正文是否完成
       */
        onEditDocFinished($scope, openType) {
            const _this = this
            const url = 'http://127.0.0.1:7900/api/GetOcxStatus'
            this.xmlAjax({
                url: url,
                method: 'post',
                data: '{"xquery":"ocxstatus"}',
                onload: function (e) {
                    if (this.status === 200 || this.status === 304) {
                        const jsonObj = JSON.parse(this.responseText.replace('\r\n', '').replace('\n', '').replace('}0', '}'))

                        window.bodyEditor = { status: jsonObj.result, lastTime: new Date() }

                        if (jsonObj.result === 'finished') {
                            var attachs = jsonObj.msg[0].body.uploadAttachList
                            $scope.$bus.emit('onEditDocFinished', attachs)

                            if (attachs && attachs.length > 0 && attachs[0].fileType === 'BODY') {
                                // 正文编辑结束猴处理
                                if ($scope.bodyfile === undefined || $scope.bodyfile === null || $scope.bodyfile.fileName === '') {
                                    for (var i = 0; i < attachs.length; i++) {
                                        if (attachs[i].originalName.indexOf('.pdf') !== -1) {
                                            $scope.bodyfile = attachs[i]
                                            $scope.bodyfile.fileName = '文件正文.pdf'
                                        }
                                    }

                                    if ($scope.bodyfile === undefined || $scope.bodyfile === null || $scope.bodyfile.fileName === '') {
                                        $scope.bodyfile = attachs[0]
                                        $scope.bodyfile.fileName = '文件正文' + attachs[0].originalName.substring(attachs[0].originalName.indexOf('.'))
                                    }
                                    $scope.bodyfile.notDelete = true
                                }

                                if (openType === 'NoTracks') {
                                    // 清稿结束
                                    $scope.wfInstance.haveDoc = 1
                                    if ($scope.vo.signedFileName) $scope.vo.signedFileName = null
                                } else if (openType === 'Redlining' || openType === 'RedliningOnce') {
                                    // 套红或重新套红
                                    $scope.wfInstance.haveDoc = 2
                                    if ($scope.vo.signedFileName) $scope.vo.signedFileName = null
                                } else if (openType === 'SignedFile') {
                                    // 盖章
                                    $scope.vo.signedFileName = attachs[0].fileName
                                } else {
                                    // 编辑正文
                                    if ($scope.wfInstance.passenger.docEditMode === 'NoTitle') {
                                        // NoTitle 模式下 haveDoc 编辑后为 1
                                        $scope.wfInstance.haveDoc = 1
                                    } else {
                                        $scope.wfInstance.haveDoc = 2
                                    }
                                    if ($scope.vo.signedFileName) $scope.vo.signedFileName = null
                                }

                                $scope.$message({
                                    type: 'success',
                                    message: _this.$tx('ecoa.webOffice.fileSaveSuccessMsg', '文件已保存成功！'),
                                    showClose: true
                                })

                                //切换到正文标签，加载正文
                                $scope.activeName = 'second'
                                _this.$nextTick(() => {
                                    _this.$bus.emit('reloadBodyFile', attachs)
                                    $scope.btnSubmitClick('AutoSave')
                                })
                            } else if (attachs && attachs.length > 0 && attachs[0].fileType === 'CpbFile') {
                                let fileurl = process.env.VUE_APP_BASE_API + '/' + $scope.wfAttachUrl + '/downloadById?inline=true&attachIds=' + attachs[0].id + '&saveAs=' + attachs[0].fileName
                                fileurl += '&markContent=' + $scope.wfInstance.orgName
                                fileurl += '&httpPort=' + location.port
                                window.open('/plugins/PDFjs/web/viewer.html?file=' + encodeURIComponent(fileurl))
                            } else {
                                // $scope.$message.success('文件已保存成功！')
                                $scope.$message.success(_this.$tx('ecoa.webOffice.fileSaveSuccessMsg', '文件已保存成功！'))
                            }
                        } else if (jsonObj.result === 'work') {
                            setTimeout(() => {
                                _this.onEditDocFinished($scope, openType)
                            }, 1000)
                        }
                    }
                }
            })
        },
        // 手动上传文件
        handleUploadChange(file, fileList) {
            const extName = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()
            if (this.accept.indexOf(extName) === -1) {
                // this.$alert('您上传的文件格式有误，仅支持' + this.accept.replace(/,/g, '、') + '格式的文件！', '提示', { confirmButtonText: '确定', type: 'warning' })
                this.$alert(this.$tx('ecoa.webOffice.errorFormatAlert', { type: this.accept.replace(/,/g, '、') }, '您上传的文件格式有误，仅支持{type}格式的文件！'), this.$tx('common.operationTip', '操作提示'), { confirmButtonText: this.$tx('pageBtns.sure', '确 定'), type: 'warning' })
                this.fileList = []
                return
            }

            const attach = {}
            attach.fileName = file.name
            attach.fileSize = formatFileSize(file.size)
            attach.fileType = 'BODY'
            attach.uploadBy = this.loginUser.personName
            attach.uploadTime = '待上传'
            attach.saveToPdf = !!(extName === '.doc' || extName === '.docx')
            attach.file = file
            if (this.openType === 'SignedFile') {
                if (extName !== '.pdf') {
                    // this.$alert('您上传的文件格式有误，仅支持PDF格式的文件！', '提示', { confirmButtonText: '确定', type: 'warning' })
                    this.$alert(this.$tx('ecoa.webOffice.errorFormatPdfAlert', '您上传的文件格式有误，仅支持PDF格式的文件！'), this.$tx('common.operationTip', '操作提示'), { confirmButtonText: this.$tx('pageBtns.sure', '确 定'), type: 'warning' })

                    this.fileList = []
                    return
                }
                attach.file.name = 'SignedFile_' + this.$vnode.context.wfInstance.bodyDocId + extName
            } else if (this.openType === 'Redlining' || this.openType === 'RedliningOnce') {
                attach.file.name = 'RedTitle_' + this.$vnode.context.wfInstance.bodyDocId + extName
            } else {
                attach.file.name = this.$vnode.context.wfInstance.bodyDocId + extName
            }

            attach.checked = false
            file.progress = 0

            this.uploadAttach = attach
        },
        submitForm() {
            if (this.flBodyfile != null && this.flBodyfile.name !== '') {
                for (var i = 0; i < this.attachments.length; i++) {
                    if (this.attachments[i].name === this.flBodyfile.name && this.attachments[i].fileType === 'BODY' && this.attachments[i].uploadTime === '待上传') {
                        this.attachments.splice(i--, 1)
                    }
                }
            }
            this.$vnode.context.bodyfile = this.uploadAttach
            this.$vnode.context.btnSubmitClick('AutoSave')
        }
    }
}
</script>

<style scoped lang="scss">
.item {
  .title {
      font-size: 14px;
      font-weight: 600;
  }
  /deep/ .el-upload--text {
      width: 100%;
  }

  /deep/ .el-link {
      padding-right: 10px;
  }
}
</style>
